<template>
    <div class="auctionList">
        
        <div class="auctionListFilter">

            <div class="line">
                <input type="text" v-model="search_name" placeholder="Search Auction" />
                <Transition name="slide-fade">
                    <button v-if="search_name" @click.prevent="search_name=''">x</button>
                </Transition>
            </div>
            
            <div class="line">
                
                <input type="text" v-model="search_state.name" placeholder="Search State" @focus="search_state.show = true" />
                <Transition name="slide-fade">
                    <button v-if="search_state.value" @click.prevent="search_state.name='';search_state.value=''">x</button>
                </Transition>
                <Transition name="slide-up">
                    <states-filter v-if="search_state.show" :selected="search_state.name" @hide-search="search_state.show = false" @select-state="(state) => {search_state.show = false;search_state.value = state.value,search_state.name = state.name}"></states-filter>
                </Transition>
            </div>

        </div>

        <TransitionGroup tag="div" name="list" class="auctionsWrap">
            <template v-if="Object.keys(state_list).length" >
                <div class="state" v-for="(states,state) in state_list" :key="state">
                    <h3>
                        <img :src="ASSETS_URL+'img/flags/'+state.toUpperCase()+'.png'" alt="US wholesale auto auction location featured in the Laser Appraiser directory" />
                        {{ us_states[state]}}
                    </h3>
                    <div class="state">
                        <TransitionGroup tag="div" name="list" class="auctions" :key="state">
                            <a v-for="auction in states" :href="home_url+'auction-run-lists/'+stateToUrlSlug(auction.state)+auction.slug" :key="auction.auctionCode">
                                <!-- <span class="vCount">
                                    <CarIcon />
                                    <span class="t">{{ auction.vehicleCount }}</span>
                                </span> -->
                                {{ auction.name }}
                            </a>
                        </TransitionGroup>
                    </div>
                </div>
            </template>
            <div v-else class="state no_data">
                <div class="auctions">
                    <p>no data found...</p>
                </div>
            </div>
        </TransitionGroup>
    </div>
</template>

<script>
import { ref } from 'vue'
import { HOME_URL , ASSETS_URL, us_states } from '../constants/envrionment';
import CarIcon from 'vue-material-design-icons/Car.vue';
import statesFilter from '../components/statesFilter.vue'

export default {
    props: ['query_state'],
    components: {
        statesFilter,
        CarIcon,
    },
    setup() {

        return {
            ASSETS_URL: ref(ASSETS_URL),
            data : ref({}),
            by_state: ref(''),
            home_url: ref(''),
            by_auction: ref(''),
            search_name: ref(''),
            search_state: ref({
                value: '',
                name: '',
                show: false
            }),
            us_states: us_states
        }
    },
    computed: {
        state_list: function() {

            let res = {},
                filtered = Array.isArray(this.data) ? this.data : Object.values(this.data || {}),
                search_state = this.search_state.value,
                search_name = this.search_name.toLowerCase();

            if(search_state){

                filtered = filtered.filter((auction) => {
                    if (auction.state == search_state)
                        return true;
                });
            }

            if(search_name){

                filtered = filtered.filter((auction) => {
                    if ((auction.name.toLowerCase()).match(search_name))
                        return true;
                });
            }

            Object.keys(filtered).forEach(key => {
                
                let row = filtered[key];

                if(typeof res[row['state']] == 'undefined'){
                    res[row['state']] = [];
                }
                
                res[row['state']].push(row);

            });

            return res;
        },
    },
    methods: {
       
        stateToUrlSlug: function (text) {

            if(!text)
                return '';

            if(typeof this.us_states[text] != 'undefined'){
                text = this.us_states[text];
            }

            let url_slug = text.toLowerCase()
                                .replace(/ /g, '-')
                                .replace(/[^\w-]+/g, '');

            return url_slug+'/';
        },
    },
    mounted: function(){

        this.home_url = HOME_URL

        this.data = this.$auctionsData;


        const queryString = window.location.search;
        if(queryString){
            
            const urlParams = new URLSearchParams(queryString);
            const search_state = urlParams.get('search_state')
            
            if(search_state){

                this.search_state.name = this.us_states[search_state]
                this.search_state.value = search_state
            }
        }
    }
}

</script>